import axios from 'axios';

import apiPaths from 'enums/apiPaths';

const logoutApi = () => {
    return axios({
        method: 'GET',
        url: apiPaths.LOGOUT
    });
};

export default logoutApi;
